import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useAiConsent = () => {
  const { aiConsentRequired } = useConfigContext();

  return {
    aiConsentRequired,
  };
};

export default useAiConsent;
